import { c as _c } from "react/compiler-runtime";
import { IcoCloseSmall16, IcoWarning16 } from '@onefootprint/icons';
type AttachmentErrorProps = {
  message: string;
  dismissLabel: string;
  durationMs: number;
  onDismiss: () => void;
};
const AttachmentError = t0 => {
  const $ = _c(14);
  const {
    message,
    dismissLabel,
    durationMs,
    onDismiss
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IcoWarning16 color="error" className="shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== message) {
    t2 = <span className="flex-1 max-md:min-w-0 max-md:break-words">{message}</span>;
    $[1] = message;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5" className="opacity-20" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${durationMs}ms`;
  let t5;
  if ($[4] !== t4) {
    t5 = <svg className="absolute inset-0 -rotate-90" viewBox="0 0 24 24" fill="none" aria-hidden="true">{t3}<circle cx="12" cy="12" r="10" pathLength={1} strokeDasharray={1} stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" className="chat-input-countdown-ring" style={{
        animationDuration: t4
      }} /></svg>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IcoCloseSmall16 className="scale-75" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== dismissLabel || $[8] !== onDismiss || $[9] !== t5) {
    t7 = <button type="button" aria-label={dismissLabel} onClick={onDismiss} className="relative shrink-0 flex items-center justify-center w-5 h-5 text-error cursor-pointer max-md:before:absolute max-md:before:-inset-2">{t5}{t6}</button>;
    $[7] = dismissLabel;
    $[8] = onDismiss;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t2 || $[12] !== t7) {
    t8 = <div role="alert" className="flex items-center gap-2 px-4 pt-3 text-caption-2 text-error">{t1}{t2}{t7}</div>;
    $[11] = t2;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
};
export default AttachmentError;